import { interpolateNumber } from 'd3-interpolate';

export const interpolateRoundToFixed = (n: number) => (a: number, b: number) => (t: number) =>
  parseFloat(interpolateNumber(a, b)(t).toFixed(n));
